import React from "react";
import StudentLeftside from "./StudentLeftside";
import Categories from "./StudentCategory";
import "./studentdashboard.css";
import { Link } from "react-router-dom";

export default function Subject() {
  return (
    <div className="dashboard-wrap bg-light">
      <StudentLeftside />

      <div className="dashboard-content py-5">
			<div className="dashboard-tlbar d-block pt-8">
						<div className="row">
							<div className="col-xl-12 col-lg-12 col-md-12">
								<nav aria-label="breadcrumb">
									<ol className="breadcrumb">
                    <li className="breadcrumb-item text-muted"><Link to="/studentdashboard">Dashboard</Link></li>
										<li className="breadcrumb-item"><Link to="#" className="text-main">Subject</Link></li>
									</ol>
								</nav>
							</div>
						</div>
					</div>
        {/* ===== PAGE HEADER / HERO ===== */}
       
									
        <hr className="mb-4" />

        {/* ===== SUBJECT LIST ===== */}
        <div className="row">
          <Categories />
        </div>

      </div>
    </div>
  );
}
